export function printSize(bytes?: number, locale: string = 'fr'): string {
  if (!bytes) return '';

  const unitsByLocale = {
    fr: ['octet', 'ko', 'Mo', 'Go', 'To', 'Po'],
    en: ['byte', 'KB', 'MB', 'GB', 'TB', 'PB'],
  };

  // Default to 'fr' if locale is not supported
  const validLocale = locale in unitsByLocale ? (locale as 'fr' | 'en') : 'fr';
  const units = unitsByLocale[validLocale];
  let size = bytes;
  let unitIndex = 0;

  // Use decimal (1000) for both locales - this is the SI standard
  while (size >= 1000 && unitIndex < units.length - 1) {
    size /= 1000;
    unitIndex++;
  }

  // Handle singular vs plural for bytes/octets
  let unit = units[unitIndex];
  if (unitIndex === 0 && size !== 1) {
    unit = validLocale === 'fr' ? 'octets' : 'bytes';
  }

  // Format number according to locale
  if (size === Math.floor(size)) {
    return `${size} ${unit}`;
  }

  // Round to 2 decimal places and format according to locale
  const rounded = Math.round(size * 100) / 100;
  const formatted =
    validLocale === 'fr'
      ? rounded.toString().replace('.', ',')
      : rounded.toString();

  return `${formatted} ${unit}`;
}
